module.exports = __webpack_public_path__ + "static/img/10.e9f1481.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/10.png
// module id = 9Wk2
// module chunks = 0